import { colors, spacing, radius, typography } from '../tokens';
const baseBadge = {
    padding: `${spacing[1]} ${spacing[3]}`,
    borderRadius: radius.xl,
    fontSize: typography.fontSize.sm,
    fontWeight: typography.fontWeight.semibold,
    display: 'inline-block',
};
export const badgeStyles = {
    success: {
        ...baseBadge,
        backgroundColor: colors.success.light,
        color: colors.success.dark,
    },
    error: {
        ...baseBadge,
        backgroundColor: colors.error.light,
        color: colors.error.dark,
    },
    warning: {
        ...baseBadge,
        backgroundColor: colors.warning.light,
        color: colors.warning.dark,
    },
    info: {
        ...baseBadge,
        backgroundColor: colors.primary[100],
        color: colors.primary[600],
    },
    neutral: {
        ...baseBadge,
        backgroundColor: colors.gray[100],
        color: colors.gray[600],
    },
};
// Semantic status mapping
export const statusBadgeStyles = {
    active: badgeStyles.success,
    scheduled: badgeStyles.info,
    expired: badgeStyles.error,
    archived: badgeStyles.neutral,
    pending: badgeStyles.warning,
};
//# sourceMappingURL=badge.js.map